export const URLParams = (data: Record<string, any>) => {
  return Object.keys(data)
    .filter((key) => {
      return data[key];
    })
    .map((key) => `${key}=${encodeURIComponent(data[key])}`.replaceAll('--empty', 'null'))
    .join('&');
};

export const URLParamsToObject = (params: string, remove: string[] = []) => {
  return params
    .replace('?', '')
    .split('&')
    .reduce((prev, param) => {
      const [key, value] = param.split('=');

      if (remove.includes(key)) {
        return prev;
      }

      return { ...prev, [key]: value };
    }, {} as Record<string, string>);
};
